import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Pricing() {
  const navigate = useNavigate();
  
  // 🛡️ L'ÉTAT DU BOUCLIER LÉGAL
  const [cgvAcceptees, setCgvAcceptees] = useState(false);
  
  // 🌐 RÉPARATION DE L'URL POUR NETLIFY
  const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000';

  const choisirPlan = async (plan) => {
    // 🛑 VÉRIFICATION DU BOUCLIER SEULEMENT POUR LES PLANS PAYANTS
    if (plan.priceId && !cgvAcceptees) {
      alert("⚠️ Action requise : Veuillez cocher la case de protection juridique juste au-dessus des offres.");
      return;
    }

    localStorage.setItem('limiteQuestions', plan.limit);
    localStorage.setItem('planChoisi', plan.title);

    if (plan.priceId) {
      const typeDePaiement = plan.type.includes('mois') ? "subscription" : "payment";
      
      try {
        const response = await fetch(`${API_URL}/create-checkout-session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ price_id: plan.priceId, mode: typeDePaiement })
        });
        
        const data = await response.json();
        if (data.url) {
          window.location.href = data.url;
        } else {
          alert("Erreur Stripe : " + data.error);
        }
      } catch (err) {
        console.error("Erreur réseau :", err);
        alert("Impossible de joindre le serveur de paiement. Veuillez réessayer.");
      }
    } else {
      // S'il clique sur le plan Gratuit (0€), on le renvoie direct vers l'audit !
      navigate('/audit');
    }
  };

  const offresUnite = [
    { title: 'Découverte', price: '0€', type: 'Test', limit: 7, color: '#94A3B8', cardBg: 'white', textColor: '#0B1F3A', priceId: null,
      feats: ['7 questions d’audit', 'Score global cyber', 'Idéal pour tester'], 
      limits: ['❌ Pas de plan d\'action dynamique'] },

    { title: 'Starter', price: '49€', type: 'Paiement Unique', limit: 15, color: '#3B82F6', cardBg: 'white', textColor: '#0B1F3A', priceId: 'price_1TTezI1KS1vyXKN3zDyF35Ri',
      feats: ['15 questions d’audit', '1 rapport PDF', 'Accès bot (100 questions)'], 
      limits: ['❌ Pas d’accès au plan dynamique'] },
    
    { title: 'Diagnostic Pro', price: '99€', type: 'Paiement Unique', limit: 30, color: '#2563EB', cardBg: '#F0F8FF', textColor: '#0B1F3A', pop: true, badge: 'POPULAIRE', priceId: 'price_1TTfNN1KS1vyXKN3MHwfWhuY',
      feats: ['30 questions d’audit', '1 rapport PDF', 'Accès bot (100 questions)', '⚠️ Accès partiel au plan d’action'],
      limits: ['🔸 2 rapports dynamiques max'] },
    
    { title: 'Audit Complet', price: '199€', type: 'Paiement Unique', limit: 50, color: '#6C5CE7', cardBg: '#1E293B', textColor: 'white', badge: '🏆 EXPERTISE MAXIMALE', priceId: 'price_1TTfRe1KS1vyXKN3pTR1ivbb',
      feats: ['50 questions d’audit', '1 rapport complet PDF', 'Accès bot (100 questions)', '⚠️ Accès avancé au plan d’action'],
      limits: ['🔸 5 rapports dynamiques max'] }
  ];

  const offresAbonnement = [
    { title: 'Premium', price: '290€', type: '/ mois', limit: 70, color: '#F59E0B', cardBg: 'white', textColor: '#0B1F3A', badge: '👉 ÉQUILIBRE VALEUR / PRIX', priceId: 'price_1TTfU51KS1vyXKN3oGoMCyH5',
      feats: ['5 audits complets inclus', 'Accès plan d’action dynamique', 'Accès bot (usage étendu - 500q)', 'Suivi continu & Amélioration'],
      limits: ['🔸 15 rapports dynamiques max'] },
    
    { title: 'Elite', price: '490€', type: '/ mois', limit: 100, color: '#8B5CF6', cardBg: 'linear-gradient(135deg, #1E293B 0%, #0B1F3A 100%)', textColor: 'white', badge: '👑 ILLIMITÉ (Choix des Leaders)', priceId: 'price_1TTfWo1KS1vyXKN3HduwLOqF',
      feats: ['🔓 Audits illimités', '🔓 Rapports illimités', '🔓 Plan d’action dynamique illimité', '🔓 Bot IA illimité', '🔓 Optimisation & Priorisation en continu'],
      limits: ['🔓 Aucun plafond d’usage'] }
  ];

  return (
    <div style={{ fontFamily: '"Inter", sans-serif', backgroundColor: '#0B1F3A', minHeight: '100vh', color: 'white', padding: '60px 20px', textAlign: 'center' }}>
      
      {/* BOUTON RETOUR */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'left', marginBottom: '40px' }}>
        <button onClick={() => navigate(-1)} style={{ background: 'transparent', color: '#94A3B8', border: '1px solid #94A3B8', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold', transition: 'all 0.2s' }}>
          ← Retour au Tableau de Bord
        </button>
      </div>

      <h1 style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '10px' }}>Passez à la vitesse supérieure</h1>
      <p style={{ color: '#F5F7FA', opacity: 0.8, marginBottom: '50px' }}>Choisissez l'offre adaptée à votre ambition. De l'audit ponctuel au système autonome.</p>

      {/* 🛡️ LA FAMEUSE CASE À COCHER LÉGALE (LE BOUCLIER) */}
      <div style={{ marginBottom: '50px', background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '8px', display: 'inline-block', maxWidth: '800px', border: cgvAcceptees ? '2px solid #2ecc71' : '1px dashed rgba(255,255,255,0.3)', transition: 'all 0.3s ease' }}>
        <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'flex-start', gap: '15px', fontSize: '14px', textAlign: 'left', color: '#F5F7FA' }}>
          <input 
            type="checkbox" 
            checked={cgvAcceptees} 
            onChange={(e) => setCgvAcceptees(e.target.checked)} 
            style={{ width: '24px', height: '24px', cursor: 'pointer', marginTop: '2px' }} 
          />
          <span style={{ lineHeight: '1.5' }}>
            Je reconnais que l'accès aux outils et aux rapports est immédiat après le paiement. Par conséquent, <b>j'accepte expressément les Conditions Générales et je renonce à mon droit de rétractation de 14 jours</b> (art. L221-28 du Code de la consommation).
          </span>
        </label>
      </div>

      {/* 📦 SECTION 1 : OFFRES À L'UNITÉ */}
      <h2 style={{ fontSize: '28px', color: '#60A5FA', marginBottom: '30px', borderBottom: '2px solid #60A5FA', display: 'inline-block', paddingBottom: '10px' }}>
        📦 Offres à l'unité
      </h2>
      
      <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center', maxWidth: '1200px', margin: '0 auto 60px auto' }}>
        {offresUnite.map((plan, i) => (
          <div key={i} style={{ flex: '1 1 260px', maxWidth: '300px', background: plan.cardBg, color: plan.textColor, padding: '40px 20px', borderRadius: '12px', position: 'relative', display: 'flex', flexDirection: 'column', border: plan.pop ? `2px solid ${plan.color}` : `1px solid transparent`, boxShadow: plan.pop ? `0 15px 35px rgba(0,0,0,0.4)` : '0 10px 30px rgba(0,0,0,0.2)', transform: plan.pop ? 'scale(1.05)' : 'scale(1)', zIndex: plan.pop ? 10 : 1 }}>
            
            {plan.badge && <div style={{ position: 'absolute', top: '-14px', left: '50%', transform: 'translateX(-50%)', background: plan.color, color: 'white', padding: '6px 16px', borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', whiteSpace: 'nowrap' }}>{plan.badge}</div>}
            
            <h3 style={{ fontSize: '22px', fontWeight: 'bold', margin: '0 0 10px 0' }}>{plan.title}</h3>
            <div style={{ fontSize: '42px', fontWeight: 'bold', color: plan.color }}>{plan.price}</div>
            <div style={{ fontSize: '14px', opacity: 0.7, marginBottom: '20px', textTransform: 'uppercase' }}>{plan.type}</div>
            
            <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', marginBottom: '15px', flexGrow: 1 }}>
              {plan.feats.map((f, j) => <li key={j} style={{ marginBottom: '12px', fontSize: '15px' }}><span style={{ color: plan.color, fontWeight: 'bold', marginRight: '8px' }}>✔</span> {f}</li>)}
            </ul>
            
            <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', marginBottom: '30px' }}>
              {plan.limits.map((l, j) => <li key={j} style={{ marginBottom: '12px', fontSize: '14px', fontWeight: 'bold', color: plan.title === 'Starter' || plan.title === 'Découverte' ? '#EF4444' : '#F59E0B' }}>{l}</li>)}
            </ul>
            
            <div>
              <button 
                onClick={() => choisirPlan(plan)} 
                style={{ 
                  width: '100%', padding: '16px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', transition: 'all 0.2s ease', 
                  background: plan.price === '0€' ? 'transparent' : plan.color, 
                  color: plan.price === '0€' ? plan.color : 'white', 
                  border: plan.price === '0€' ? `2px solid ${plan.color}` : 'none',
                  opacity: (plan.priceId && !cgvAcceptees) ? 0.5 : 1 
                }}
              >
                {plan.priceId ? "Payer et Démarrer" : "Commencer Gratuit"}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* 🔁 SECTION 2 : ABONNEMENTS */}
      <h2 style={{ fontSize: '28px', color: '#F59E0B', marginBottom: '30px', borderBottom: '2px solid #F59E0B', display: 'inline-block', paddingBottom: '10px' }}>
        🔁 Abonnements (Suivi Continu)
      </h2>

      <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', justifyContent: 'center', maxWidth: '900px', margin: '0 auto' }}>
        {offresAbonnement.map((plan, i) => (
          <div key={i} style={{ flex: '1 1 350px', background: plan.cardBg, color: plan.textColor, padding: '40px 30px', borderRadius: '15px', position: 'relative', display: 'flex', flexDirection: 'column', border: `2px solid ${plan.color}`, boxShadow: '0 20px 50px rgba(0,0,0,0.3)' }}>
            
            <div style={{ position: 'absolute', top: '-15px', left: '50%', transform: 'translateX(-50%)', background: plan.color, color: plan.title === 'Premium' ? '#0B1F3A' : 'white', padding: '6px 20px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', letterSpacing: '1px', whiteSpace: 'nowrap' }}>{plan.badge}</div>
            
            <h3 style={{ fontSize: '26px', fontWeight: 'bold', margin: '0 0 10px 0' }}>{plan.title}</h3>
            <div style={{ fontSize: '48px', fontWeight: 'bold', color: plan.color }}>{plan.price}</div>
            <div style={{ fontSize: '14px', opacity: 0.7, marginBottom: '25px', textTransform: 'uppercase' }}>{plan.type}</div>
            
            <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', marginBottom: '15px', flexGrow: 1 }}>
              {plan.feats.map((f, j) => <li key={j} style={{ marginBottom: '15px', fontSize: '16px' }}><span style={{ color: plan.color, fontWeight: 'bold', marginRight: '10px' }}>✔</span> {f}</li>)}
            </ul>

            <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', marginBottom: '30px' }}>
              {plan.limits.map((l, j) => <li key={j} style={{ marginBottom: '12px', fontSize: '15px', fontWeight: 'bold', color: plan.title === 'Premium' ? '#F59E0B' : '#2ECC71' }}>{l}</li>)}
            </ul>
            
            <div>
              <button 
                onClick={() => choisirPlan(plan)} 
                style={{ width: '100%', padding: '18px', borderRadius: '8px', background: plan.color, color: plan.title === 'Premium' ? '#0B1F3A' : 'white', border: 'none', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer', transition: 'all 0.2s ease', opacity: !cgvAcceptees ? 0.5 : 1 }}
              >
                S'abonner en {plan.title}
              </button>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
}

export default Pricing;